import axios from "../config/axios";

const API_BASE = "/cashbook";

const withScope = (params = {}, { locationHubId, ownerUserId, account } = {}) => ({
  ...params,
  ...(locationHubId ? { location_hub_id: locationHubId } : {}),
  ...(ownerUserId ? { owner_user_id: ownerUserId } : {}),
  ...(account ? { account } : {}),
});

export const cashbookService = {
  getReport: (date, locationHubId, ownerUserId, account) =>
    axios.get(`${API_BASE}/report`, {
      params: withScope(date ? { date } : {}, { locationHubId, ownerUserId, account }),
    }),

  getRange: (fromDate, toDate, locationHubId, ownerUserId, account) =>
    axios.get(`${API_BASE}/range`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId, account },
      ),
    }),

  getDayBook: (fromDate, toDate, locationHubId, ownerUserId) =>
    axios.get(`${API_BASE}/day-book`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId },
      ),
    }),

  getOpeningBalance: (locationHubId, ownerUserId) =>
    axios.get(`${API_BASE}/opening-balance`, {
      params: withScope({}, { locationHubId, ownerUserId }),
    }),
  setOpeningBalance: (data) => axios.post(`${API_BASE}/opening-balance`, data),

  transferToAdmin: (locationHubId, toLocationHubId) => axios.post(`${API_BASE}/transfer-to-admin`, {
    location_hub_id: locationHubId || undefined,
    to_location_hub_id: toLocationHubId || undefined,
  }),

  createEntry: (data) => axios.post(`${API_BASE}/entries`, data),
  updateEntry: (entryId, data) => axios.put(`${API_BASE}/entries/${entryId}`, data),
  deleteEntry: (entryId) => axios.delete(`${API_BASE}/entries/${entryId}`),

  exportPdf: (fromDate, toDate, locationHubId, ownerUserId, account) =>
    axios.get(`${API_BASE}/export/pdf`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId, account },
      ),
      responseType: "blob",
    }),

  exportExcel: (fromDate, toDate, locationHubId, ownerUserId, account) =>
    axios.get(`${API_BASE}/export/excel`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId, account },
      ),
      responseType: "blob",
    }),
};

export default cashbookService;
